import React from 'react';
import './components.css';

const Footer = () => {

    return (
        
        <div className='footer'>
            <style>
  @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Condensed:wght@100;300;400&family=IBM+Plex+Sans:wght@100&display=swap');
</style>
            <h3>Created by Group 1 🐷</h3>
        </div>
    )
}

export default Footer; 
